
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoadingMask',
  props: {
    /** 是否显示蒙层 */
    visible: {
      type: Boolean,
      default: false
    },
    /** 提示文字 */
    text: {
      type: String,
      default: '加载中，请稍候…'
    },
    /** 深色模式 */
    isDark: {
      type: Boolean,
      default: false
    }
  }
})
